import { OrganizationTag } from './organization/organization-tag.model';

export class UserInformation {
  public isAdmin: boolean;
  public organizationList: OrganizationTag[] = [];

  constructor(data: any = {}) {
    this.isAdmin = data?.isAdmin ?? false;
    this.organizationList = data?.organizationList ?? [];
  }

  public static createFromApi(data: any = {}): UserInformation {
    const organizationList = (data?.organizations ?? data?.organizationList ?? [])
      .map((organizationResponse: any) => OrganizationTag.createFromApi(organizationResponse));
    return new UserInformation({
      isAdmin: data?.isAdmin ?? false,
      organizationList,
    });
  }
}
